// extracted by mini-css-extract-plugin
module.exports = {"section":"ShippingSection_section__1CS19","shippingForm":"ShippingSection_shippingForm__1peKE"};